import { i18n } from "services/i18nService";
import { getDocument } from "services/sosInventoryService/sosApi";
import { formatDate } from "services/utility/dates";
import {
  extractName,
  formatMoney,
  formatDocumentInfo,
  formatSync,
} from "services/utility/formatting";

export const purchaseConfig = {
  columns: [
    {
      heading: i18n("columns.Vendor"),
      apiName: "vendor",
      formatFunc: extractName,
      sortable: true,
    },
    {
      heading: i18n("columns.PurchaseDate"),
      apiName: "date",
      sortDirection: "desc",
      sortable: true,
      formatFunc: formatDate,
      defaultSort: true,
    },
    {
      heading: i18n("columns.Type"),
      apiName: "type",
      sortable: true,
      minWidth: "8rem",
    },
    {
      heading: i18n("columns.ReferenceNumber"),
      apiName: "refNumber",
      sortable: true,
    },
    {
      heading: i18n("columns.Amount"),
      apiName: "amount",
      sortable: true,
      formatFunc: formatMoney,
      align: "right",
    },
    {
      heading: i18n("columns.Sync"),
      apiName: "syncMessage",
      sortable: true,
      formatFunc: formatSync,
      maxWidth: "20rem",
    },
    {
      heading: i18n("columns.Documents"),
      apiName: "documents",
      formatFunc: formatDocumentInfo,
      apiFunc: getDocument,
      isDocument: true,
      maxWidth: "12rem",
    },
  ],
};
